/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2021-2022 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import messages from "./messages/messages.json";
import {
  getTranslatedMessages,
  getTriAppConfig,
} from "@tririga/tririga-react-components";
 
const VERSION = process.env.REACT_APP_VERSION;
const DEAFAULT_USER_LANGUAGE_ID = 1;

const baseMessages = {
  ...messages,
};

let appMessages = null;

export const APP_LOG_IN_TO = "APP_LOG_IN_TO";
export const APP_ADMIN_CONSOLE = "APP_ADMIN_CONSOLE";
export const APP_USERNAME = "APP_USERNAME";
export const APP_PASSWORD = "APP_PASSWORD";
export const APP_OLD_PASSWORD = "APP_OLD_PASSWORD";
export const APP_NEW_PASSWORD = "APP_NEW_PASSWORD";
export const APP_CONFIRM_NEW_PASSWORD = "APP_CONFIRM_NEW_PASSWORD";
export const APP_CONTINUE = "APP_CONTINUE";
export const APP_INVALID_USERNAME_PASSWORD = "APP_INVALID_USERNAME_PASSWORD";
export const APP_PASSWORD_CHANGE_REQUIRED = "APP_PASSWORD_CHANGE_REQUIRED";
export const APP_PASSWORD_CHANGE_SUCCESSFUL = "APP_PASSWORD_CHANGE_SUCCESSFUL";
export const APP_ERROR = "APP_ERROR";
export const APP_SYSTEM_ERROR = "APP_SYSTEM_ERROR";


export function getMessage(label) {
  return appMessages[label];
}

export async function initMessages() {
  if (process.env.NODE_ENV==='development') {
      appMessages = baseMessages;
  } else if (!appMessages) {
    try {
      appMessages = await getTranslatedMessages(
        baseMessages,
        getTriAppConfig().appExposedName + VERSION,
        DEAFAULT_USER_LANGUAGE_ID // Using default language as login does not have handle to user information.
      );
      
      localStorage.setItem("triPlatformLoginMessages",JSON.stringify(appMessages));
    } catch (error) {
      alert(
        'Unable to get translations, defaulting to English -' + error
      );
      appMessages = baseMessages;
    }
  }
}